import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import styles from './_myRoutesModule.css'
import paginator from 'services/paginator/paginator'
import { FormattedMessage } from 'react-intl'
import { selectUserId } from 'services/user/selectors'
import * as routeActions from 'services/routes/actions'
import RouteRow from './RouteRow'
import PaginatorControls from 'components/util/PaginatorControls'
import Loader from 'components/util/Loader'
import Svg from 'components/util/Svg'

const paginatorOptions = {
  name: 'myRoutesModule',
  perPage: 20,
  maxPageButtons: 3,
}

const mapStateToProps = (state) => ({
  userId: selectUserId(state),
})

const mapDispatchToActions = {
  ...routeActions,
}

export class MyRoutes extends Component {

  static propTypes = {
    onSelect: PropTypes.func,
    loadMyRoutesPage: PropTypes.func,
    userId: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
    paginator: PropTypes.object,
  }

  state = {
    sortAttribute: 'date_created',
    sortAscending: false,
  }

  handleChangeSort = (attribute) => () => {
    const callback = this.props.paginator.loadPage

    if (this.state.sortAttribute === attribute) {
      this.setState({ sortAscending: !this.state.sortAscending }, callback)
    } else {
      this.setState({
        sortAttribute: attribute,
        sortAscending: false,
      }, callback)
    }
  }

  handleClickRoute = (route) => () => {
    this.props.onSelect(route)
  }

  loadPaginatorPage = ({ limit, offset }) => {
    const { sortAscending, sortAttribute } = this.state
    return this.props.loadMyRoutesPage({
      cache: true,
      limit,
      offset,
      userId: this.props.userId,
      searchTerm: '',
      orderBy: `${sortAscending ? '' : '-'}${sortAttribute}`,
    })
  }

  render () {
    const { paginator: { results, loading }} = this.props

    return (
      <div className={styles.container}>
        <table className={styles.table}>
          <thead>
            <tr className={styles.thead}>
              <th className={styles.thSortable} onClick={this.handleChangeSort('distance')}>
                <FormattedMessage
                  id='routes.my_routes_module.distance_header'
                  defaultMessage='Distance'
                />
                {this.state.sortAttribute === 'distance' ?
                  <Svg
                    className={styles.sortArrow}
                    name={`carat_${this.state.sortAscending ? 'up' : 'down' }`}
                  />
                : null}

              </th>
              <th className={styles.thSortable} onClick={this.handleChangeSort('date_created')}>
                <FormattedMessage
                  id='routes.my_routes_module.name_created_header'
                  defaultMessage='Name, Created Date'
                />
                {this.state.sortAttribute === 'date_created' ?
                  <Svg
                    className={styles.sortArrow}
                    name={`carat_${this.state.sortAscending ? 'up' : 'down' }`}
                  />
                : null}
              </th>
              <th className={styles.th}>
                <FormattedMessage
                  id='routes.my_routes_module.location_header'
                  defaultMessage='Location'
                />
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan='3'>
                <div className={styles.body}>

                  {loading ?
                    <div className={styles.emptyTable}>
                      <div className={styles.tableLoader}>
                        <Loader
                          type='pulse'
                          height={60}
                          width={60}
                          style={{ marginTop: 150 }}
                        />
                      </div>
                    </div>
                  : null}

                  {!loading && results && results.length ?
                    <table>
                      <tbody>
                        {results.map((route, i) => (
                          <RouteRow
                            key={i}
                            route={route}
                            onClick={this.handleClickRoute(route)}
                          />
                        ))}
                      </tbody>
                    </table>
                  : null}

                  {!loading && results && !results.length ?
                    <div className={styles.emptyTable}>
                      <FormattedMessage
                        id='routes.my_routes_module.no_routes'
                        defaultMessage='No routes found.'
                      />
                    </div>
                  : null}

                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <div className={styles.controls}>
          {results && results.length ?
            <PaginatorControls {...this.props.paginator} />
          : null }
        </div>
      </div>
    )
  }
}

export const Table = paginator(paginatorOptions)(MyRoutes)
export default connect(mapStateToProps, mapDispatchToActions)(Table)
